import styled from 'styled-components/macro';

const IconTitle = styled.span`
  display: inline-block;
  width: 100%;
  margin-top: 10px;
  word-break: keep-all;
`;

export default IconTitle;
